/*
  Violet — Subtl Beauty's in-house shade matcher. The flyout, phase one.

  A dialog from the right on any shade-match entry point on the SSD landing
  page ([data-open-chat] and #openchat, which used to open Kustomer chat). It
  asks for a selfie, sends it to the subtl-violet Worker, and speaks the
  result. The page is driven only through the bridge the page script exposes
  (window.SubtlSSD10A): applyMatch() writes the match the way a Kustomer match
  always has, addToBag() is the page's own add.

  Spec (siena-replacement-spec.md, 2026-09-07):
  - camera or upload; the camera opens a live view in the flyout, with the
    file input as the keyboard-reachable fallback
  - a photo-quality check before upload (too dark, blown out): ask for another
    photo, which is not "asking to resend"
  - every read is preselected; below the confidence threshold the runner-up
    shows beneath as "or try this one"
  - the recommendation persists; reopening shows the last result; "re-match"
    starts a fresh selfie without losing the current match until a new one lands
  - the language rules are enforced in the Worker; the copy here follows them
    too (no dashes, "stak")
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-violet]');
  var cfgEl = document.querySelector('[data-violet-config]');
  if (!root || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.endpoint || !cfg.secret) return;
  var S = cfg.strings || {};
  var STORE = 'subtl:violet';

  var panel = root.querySelector('[data-violet-panel]');
  var thread = root.querySelector('[data-violet-thread]');
  var chips = root.querySelector('[data-violet-chips]');
  var form = root.querySelector('[data-violet-form]');
  var text = root.querySelector('[data-violet-text]');
  var camera = root.querySelector('[data-violet-camera]');
  var upload = root.querySelector('[data-violet-upload]');
  var camView = root.querySelector('[data-violet-cam]');
  var camVideo = root.querySelector('[data-violet-cam-video]');

  var state = { open: false, matchId: null, revision: 0, code: null, runnerUp: null, confidence: 0, title: '', busy: false, thread: [], lastFocus: null, openedSent: false, email: null, picks: null, more: false };
  try {
    var saved = JSON.parse(window.localStorage.getItem(STORE) || 'null');
    if (saved && Array.isArray(saved.thread)) {
      state.matchId = saved.matchId || null; state.revision = saved.revision || 0; state.code = saved.code || null;
      state.runnerUp = saved.runnerUp || null; state.confidence = saved.confidence || 0; state.title = saved.title || ''; state.thread = saved.thread; state.email = saved.email || null;
      state.picks = saved.picks || null; state.more = !!saved.more;
    }
  } catch (e) { /* private mode: the conversation just does not persist */ }

  function persist() {
    try {
      window.localStorage.setItem(STORE, JSON.stringify({
        matchId: state.matchId, revision: state.revision, code: state.code, runnerUp: state.runnerUp, confidence: state.confidence, title: state.title, email: state.email, picks: state.picks, more: state.more,
        thread: state.thread.filter(function (m) { return m.t !== 'typing' && m.t !== 'progress'; }).slice(-30),
      }));
    } catch (e) { /* ignore */ }
  }

  // The match travels with the shopper: a page they open later has the
  // bridge but not this thread's state in memory, so the picks Violet made
  // on the selfie are handed over on load. The sitewide record applies the
  // shades themselves (assets/violet-shade-match.js).
  (function () { var p = page(); if (p && p.setPicks && state.picks) p.setPicks(state.picks); })();

  // The page bridge: the landing page's own, else the sitewide one
  // (assets/violet-page.js). Read lazily; both load before this script.
  function page() { return window.SubtlSSD10A || window.SubtlVioletPage || null; }
  function fill(tpl, map) { return String(tpl || '').replace(/\{(\w+)\}/g, function (w, k) { return map && map[k] != null ? map[k] : w; }); }
  function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
  function btn(cls, label, onClick) { var b = el('button', cls, label); b.type = 'button'; b.addEventListener('click', onClick); return b; }

  // ── Thread ──────────────────────────────────────────────────────────────

  function push(msg) {
    state.thread.push(msg);
    // The save step stays at the bottom of the thread, whatever comes after it.
    if (msg.t !== 'save' && msg.t !== 'typing') {
      var i = state.thread.findIndex(function (x) { return x.t === 'save' && !x.done; });
      if (i !== -1 && i !== state.thread.length - 1) { var sv = state.thread.splice(i, 1)[0]; state.thread.push(sv); }
    }
    render(); persist();
  }
  function dropTyping() { stopProgress(); state.thread = state.thread.filter(function (m) { return m.t !== 'typing' && m.t !== 'progress'; }); }

  // Which side of the thread a message sits on, for grouping and tails.
  // Cards (start, rec, hand, fall, save) sit on Violet's side but outside her
  // runs, so the avatar and tail land on her last spoken bubble, not a card.
  function side(m) { return !m ? '' : (m.t === 'u' || m.t === 'img') ? 'u' : (m.t === 'a' || m.t === 'typing' || m.t === 'progress') ? 'a' : 'c'; }

  function render() {
    thread.innerHTML = '';
    state.thread.forEach(function (m, i) {
      var node = bubble(m); if (!node) return;
      var prev = state.thread[i - 1], next = state.thread[i + 1];
      node.classList.add('vio__item', 'vio__item--' + side(m));
      if (side(prev) === side(m)) node.classList.add('is-cont');
      if (side(next) !== side(m)) node.classList.add('is-last');
      // Violet's coin beside the last bubble of each of her runs.
      if (side(m) === 'a' && side(next) !== 'a' && cfg.marks && cfg.marks.avatar) {
        var av = el('span', 'vio__item-avatar'); av.setAttribute('aria-hidden', 'true'); av.innerHTML = cfg.marks.avatar; node.appendChild(av);
      }
      if (m.t === 'img' && next && next.t === 'progress') node.classList.add('is-scanning');
      thread.appendChild(node);
    });
    var last = state.thread[state.thread.length - 1] || {};
    // The composer shows once there is a match to talk about: after a
    // recommendation, an answer, and on re-open (the Worker still has the
    // selfie for 90 days, so a comment re-reads it without a new photo).
    // Any card that follows a match keeps the composer, the handoff and the
    // picker fallback included: a shopper who comes back later, or who did
    // not take the chat, can still say more or attach a new photo.
    var talking = !!state.matchId && !state.busy && (last.t === 'rec' || last.t === 'a' || last.t === 'u' || last.t === 'save' || last.t === 'shop' || last.t === 'hand' || last.t === 'alt' || last.t === 'fall' || last.t === 'img' || (last.t === 'start' && last.again));
    chips.hidden = !talking;
    form.hidden = !talking;
    thread.scrollTop = thread.scrollHeight;
    syncFab();
  }

  function bubble(m) {
    switch (m.t) {
      case 'a': {
        var a = el('div', 'vio__msg vio__msg--a', m.text);
        if (m.link) {
          a.appendChild(document.createTextNode(' '));
          var lk = el('a', 'vio__inline-link', m.link); lk.href = m.action === 'retry' ? '#' : '#ssd10-shade';
          lk.addEventListener('click', function (e) {
            e.preventDefault();
            if (m.action === 'retry') { if (state.lastImage && !state.busy) send('/match', { image: state.lastImage, source: cfg.source || 'ssd-10a', unavailable: unavailableCodes(), session: sessionId() }); }
            else toPicker();
          });
          a.appendChild(lk);
        }
        return a;
      }
      case 'u': return el('div', 'vio__msg vio__msg--u', m.text);
      case 'img': { var d = el('div', 'vio__selfie'); d.setAttribute('role', 'img'); d.setAttribute('aria-label', S.selfieAlt || 'Your selfie'); d.style.backgroundImage = 'url(' + m.src + ')'; return d; }
      case 'progress': return progressCard();
      case 'typing': { var t = el('div', 'vio__typing'); t.setAttribute('aria-label', S.typing || 'Violet is typing'); t.setAttribute('role', 'status'); for (var i = 0; i < 3; i++) t.appendChild(el('span')); return t; }
      case 'start': return startCard();
      case 'rec': return recCard(m);
      case 'alt': return altCard(m);
      case 'hand': return handoffCard(m);
      case 'fall': return fallbackCard(m);
      case 'save': return saveCard(m);
      case 'shop': return shopCard(m);
    }
    return null;
  }

  // ── Companions: the tools and refills that go with the stak ─────────────
  // The catalog comes from the page (snippets/ssd-10a-violet.liquid renders
  // the section's companion list). Shade-keyed refills follow the match at
  // render time: Cream Concealer Refill by code, BB Powder Refill by the
  // paired BB shade. Everything else sells its first buyable variant.
  var COMPANIONS = Array.isArray(cfg.companions) ? cfg.companions : [];
  var CODE_RE = /^0\d\d[CNW]$/, BB_RE = /^(Fair|Light|Medium|Deep|Deepest) \d[CNW]$/;

  function money(cents) { var n = Number(cents || 0) / 100; return '$' + (n % 1 ? n.toFixed(2) : String(n)); }
  function companionFor(handle) { return COMPANIONS.find(function (c) { return c.handle === handle; }) || null; }

  function resolveCompanion(c, code) {
    var vs = Array.isArray(c.variants) ? c.variants : [];
    var byCode = vs.some(function (v) { return CODE_RE.test(v.t); });
    var byBB = !byCode && vs.some(function (v) { return BB_RE.test(v.t); });
    var want = null;
    if (byCode) want = code || null;
    else if (byBB) { var p = page(); want = code && p ? (p.pairingFor(code).bb || null) : null; }
    var v = null;
    if (byCode || byBB) { if (want) v = vs.find(function (x) { return x.t === want; }) || null; }
    else v = vs.find(function (x) { return x.a; }) || vs[0] || null;
    return { variant: v, shade: (byCode || byBB) ? (want || '') : '', keyed: byCode || byBB };
  }

  // What is buyable right now, for a message: the tiles, and the list the
  // Worker may point to (it never names a companion the page cannot sell).
  function sellable(handles) {
    return handles.map(companionFor).filter(Boolean).map(function (c) {
      var r = resolveCompanion(c, state.code);
      return r.variant && r.variant.a ? { c: c, r: r } : null;
    }).filter(Boolean);
  }
  function companionList() {
    return sellable(COMPANIONS.map(function (c) { return c.handle; })).map(function (it) { return { handle: it.c.handle, name: it.c.title, price: money(it.r.variant.p) }; });
  }

  function shopCard(m) {
    var items = sellable(m.handles && m.handles.length ? m.handles : COMPANIONS.map(function (c) { return c.handle; }));
    if (!items.length) return null;
    var heading = m.heading || S.shopHeading || 'Goes with your stak';
    var card = el('section', 'vio__shop');
    card.setAttribute('aria-label', heading);
    card.appendChild(el('span', 'vio__shop-title', heading));
    var row = el('div', 'vio__tiles');
    items.forEach(function (it) {
      var c = it.c, v = it.r.variant;
      var tile = el('div', 'vio__tile');
      var img = el('img', 'vio__tile-img'); img.alt = ''; img.loading = 'lazy'; img.width = 128; img.height = 128;
      if (c.image) img.src = c.image;
      tile.appendChild(img);
      tile.appendChild(el('span', 'vio__tile-name', c.title));
      if (it.r.shade) tile.appendChild(el('span', 'vio__tile-shade', fill(S.shopInShade || 'In {shade}', { shade: it.r.shade })));
      tile.appendChild(el('span', 'vio__tile-price', money(v.p)));
      var name = c.title + (it.r.shade ? ' in ' + it.r.shade : '');
      var b = btn('vio__btn vio__btn--ghost vio__tile-btn', S.shopAdd || 'Add', function () { addCompanion(c, it.r, b); });
      b.setAttribute('aria-label', fill(S.shopAddAria || 'Add {name} to bag', { name: name }));
      tile.appendChild(b);
      row.appendChild(tile);
    });
    card.appendChild(row);
    return card;
  }

  // The Tools and Refills follow-ups, answered on the page: Violet advises,
  // she does not sell, so companions only ever appear when asked for. No
  // Worker round trip; the catalog and the match are both already here.
  function showCompanions(kind) {
    var handles = COMPANIONS.filter(function (c) { return kind === 'refills' ? c.refill : !c.refill; }).map(function (c) { return c.handle; });
    var items = sellable(handles);
    if (kind === 'refills') {
      // A shade refill the match keys to but the store cannot sell in that
      // shade right now is named, not silently dropped.
      var missing = COMPANIONS.filter(function (c) { return c.refill; }).map(function (c) { return { c: c, r: resolveCompanion(c, state.code) }; })
        .filter(function (x) { return x.r.keyed && x.r.shade && !(x.r.variant && x.r.variant.a); }).map(function (x) { return x.c.title; });
      var reply = items.length ? (S.refillsReply || 'The pans twist out and a refill twists in, so you keep the stak and replace only what runs low. Yours are already in your shade.') : (S.refillsNone || 'Your shade’s refills are out of stock right now. Save your match below and I will tell you when they are back.');
      if (items.length && missing.length) reply += ' ' + fill(S.refillsMissing || 'The {name} is out of stock in your shade right now; save your match below and I’ll tell you when it’s back.', { name: missing.join(' and the ') });
      push({ t: 'a', text: reply });
      if (items.length) push({ t: 'shop', handles: handles, heading: S.refillsHeading || 'Your refills' });
      else if (!knownEmail() && !state.thread.some(function (x) { return x.t === 'save'; })) push({ t: 'save' });
      return;
    }
    push({ t: 'a', text: items.length ? (S.toolsReply || 'Your Deluxe already comes with the four brushes, the cleaner and a mini brush. If you want extras, these are the ones I would add.') : (S.toolsNone || 'Your Deluxe already comes with the four brushes, the cleaner and a mini brush, so you need nothing else to get started.') });
    if (items.length) push({ t: 'shop', handles: handles, heading: S.toolsHeading || 'The extras I would add' });
  }

  function addCompanion(c, r, button) {
    var v = r.variant;
    if (!v || state.adding) return;
    state.adding = true;
    if (button) button.disabled = true;
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var item = { id: v.id, quantity: 1, properties: { _violet_companion: c.handle } };
    if (state.matchId) item.properties._violet_match_id = state.matchId;
    if (r.keyed && r.shade) { item.properties._shade_match = r.shade; item.properties._shade_matched_by = 'violet'; }
    var name = c.title + (r.shade ? ' in ' + r.shade : '');
    fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (res) { if (!res.ok) throw new Error('add'); return res.json().catch(function () { return null; }); })
      .then(function () {
        push({ t: 'a', text: fill(S.shopAdded || 'Added the {name} to your bag.', { name: name }) });
        var p = page(); if (p && typeof p.refreshCart === 'function') p.refreshCart();
        // The same after-add path the page takes: Rebuy's Smart Cart, the
        // theme's cart event, and the match id onto the cart attributes.
        var sc = window.Rebuy && window.Rebuy.SmartCart;
        if (sc && sc.status === 'ready' && typeof sc.show === 'function') sc.show();
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        document.dispatchEvent(new CustomEvent('subtl:ssd10:added', { detail: { code: state.code, companion: c.handle } }));
      })
      .catch(function () { push({ t: 'a', text: S.shopAddFailed || 'That one did not make it into your bag. Try once more.' }); })
      .then(function () { state.adding = false; if (button) button.disabled = false; });
  }

  // ── Save your match: the email capture ──────────────────────────────────
  // The moment there is an email, the match follows the customer: Shopify
  // tag, Kustomer record, the Klaviyo event with the shade on the profile,
  // and a list subscription so the follow-up flows can send.
  function saveCard(m) {
    var c = el('section', 'vio__save');
    c.setAttribute('aria-label', S.saveTitle || 'Save your match');
    if (m.done) {
      c.appendChild(el('span', 'vio__save-done', fill(S.saved || 'Saved. Your match is on file for {email}, and I will be in touch.', { email: m.email || state.email || '' })));
      return c;
    }
    c.appendChild(el('span', 'vio__save-title', S.saveTitle || 'Save your match'));
    c.appendChild(el('span', 'vio__save-body', S.saveBody || 'Keep your shade on file, and get first word when Violet learns every shade on the site.'));
    var f = el('form', 'vio__save-form');
    var input = el('input', 'vio__text');
    input.type = 'email'; input.required = true; input.autocomplete = 'email'; input.placeholder = S.savePlaceholder || 'Your email';
    input.setAttribute('aria-label', S.savePlaceholder || 'Your email');
    var submit = el('button', 'vio__btn vio__btn--solid', S.saveCta || 'Save my match'); submit.type = 'submit';
    f.appendChild(input); f.appendChild(submit);
    var err = el('span', 'vio__save-error'); err.setAttribute('role', 'alert'); err.hidden = true;
    err.id = 'vio-save-error-' + Math.random().toString(36).slice(2, 8);
    input.setAttribute('aria-describedby', err.id);
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = String(input.value || '').trim().toLowerCase();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = S.saveInvalid || 'That does not look like an email yet.'; err.hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
      input.removeAttribute('aria-invalid');
      submit.disabled = true; err.hidden = true;
      saveMatch(email).then(function () {
        state.email = email;
        state.thread = state.thread.map(function (x) { return x.t === 'save' ? { t: 'save', done: true, email: email } : x; });
        render(); persist();
      }).catch(function () {
        submit.disabled = false; err.textContent = S.saveError || 'That did not go through. Try once more.'; err.hidden = false;
      });
    });
    c.appendChild(f);
    c.appendChild(err);
    c.appendChild(el('span', 'vio__hint', S.saveConsent || 'By saving, you agree to emails from Subtl Beauty. Unsubscribe any time.'));
    return c;
  }

  // Who the browser already knows: an email saved to Violet, the logged-in
  // Shopify customer, or Klaviyo's identity cookie. Any of these means the
  // match is logged without asking, and without touching subscription state.
  function knownEmail() {
    if (state.email) return state.email;
    if (cfg.knownEmail && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(cfg.knownEmail)) return String(cfg.knownEmail).toLowerCase();
    try {
      var m = /(?:^|; )__kla_id=([^;]+)/.exec(document.cookie);
      if (m) { var d = JSON.parse(atob(decodeURIComponent(m[1]))); if (d && d.$email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.$email)) return String(d.$email).toLowerCase(); }
    } catch (e) { /* no cookie, or not ours to read */ }
    return null;
  }

  function identifyQuietly(email) {
    return fetch(cfg.endpoint.replace(/\/$/, '') + '/identify', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret },
      body: JSON.stringify({ match_id: state.matchId, email: email }),
    }).catch(function () { /* best effort */ });
  }

  function saveMatch(email) {
    var identify = fetch(cfg.endpoint.replace(/\/$/, '') + '/identify', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret },
      body: JSON.stringify({ match_id: state.matchId, email: email }),
    }).then(function (r) { if (!r.ok) throw new Error('identify'); return r.json(); });
    // Klaviyo: identify the browser so onsite events attach, and subscribe to
    // the list (consent, double opt-in per the list's own setting).
    try { if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['identify', { $email: email }]); } catch (e) { /* ignore */ }
    if (cfg.klaviyo && cfg.klaviyoList) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyo), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Violet shade match',
          profile: { data: { type: 'profile', attributes: { email: email, properties: { shade_code: state.code, shade_match_id: state.matchId } } } },
        }, relationships: { list: { data: { type: 'list', id: cfg.klaviyoList } } } } }),
      }).catch(function () { /* best effort; the server event still lands */ });
    }
    return identify;
  }


  function startCard() {
    var c = el('div', 'vio__start');
    var row = el('div', 'vio__start-row');
    row.appendChild(btn('vio__btn vio__btn--solid', S.take || 'Take a selfie', openCamera));
    row.appendChild(btn('vio__btn vio__btn--ghost', S.upload || 'Upload a photo', function () { upload.click(); }));
    c.appendChild(row);
    c.appendChild(el('span', 'vio__hint', S.hint || 'Natural light, no filter, face the camera.'));
    return c;
  }

  var ROLES = [
    { role: 'concealer', name: 'Cream Concealer', handle: 'stackable-travel-cream-concealer-medium-coverage', badge: S.badgeYours || 'YOUR SHADE' },
    { role: 'bb', name: 'BB Powder', handle: 'bb-powder', badge: S.badgeMatched || 'MATCHED' },
    { role: 'bronzer', name: 'Powder Bronzer', handle: 'travel-stackable-mini-powder-bronzer', badge: S.badgeMatched || 'MATCHED' },
    { role: 'lipcheek', name: 'Lip and Cheek', handle: 'stackable-lip-and-cheek-tint', badge: S.badgeMatched || 'MATCHED' },
    { role: 'eyeshadow', name: 'Eyeshadow Duo', handle: '2-in-1-stackable-powder-eyeshadow-matte-and-shimmer', badge: S.badgeMatched || 'MATCHED' },
  ];

  // The rows of the recommendation card. A sitewide bridge decides the set
  // for its page (the Deluxe's pods, the Starter Stak's, or the current
  // product plus the best-sellers); the landing page's bridge has no set,
  // so its five fixed roles are resolved from the pairing as before.
  function recRows(p, code) {
    if (p && typeof p.set === 'function') {
      return p.set(code, { all: state.more }).map(function (r) {
        return { role: r.role, name: r.name, shade: r.shade, pan: r.pan, badge: r.role === 'concealer' ? (S.badgeYours || 'YOUR SHADE') : (S.badgeMatched || 'MATCHED'), available: r.available, url: rowUrl(r.url || (r.handle ? '/products/' + r.handle : ''), r.variantId) };
      });
    }
    var pairing = p ? p.pairingFor(code) : { concealer: code };
    return ROLES.map(function (r) {
      var shade = pairing[r.role]; if (!shade) return null;
      return { role: r.role, name: r.name, shade: shade, pan: p && p.panFor ? p.panFor(r.role, shade) : '', badge: r.badge, available: true, url: rowUrl(r.handle ? '/products/' + r.handle : '', null) };
    }).filter(Boolean);
  }
  // Each row links to its product page. The variant id preselects the shade
  // where the page knows it; elsewhere the sitewide record selects it on
  // arrival (assets/violet-shade-match.js), so a plain product link works too.
  function rowUrl(base, variantId) {
    if (!base) return '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = base.charAt(0) === '/' && root !== '/' && base.indexOf(root) !== 0 ? root.replace(/\/$/, '') + base : base;
    return variantId ? path + (path.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId : path;
  }

  function recCard(m) {
    var p = page();
    var c = el('section', 'vio__rec');
    c.setAttribute('aria-label', S.recAria || 'Your recommendation');
    if (m.title) c.appendChild(el('h3', 'vio__rec-title', m.title));
    c.appendChild(el('p', 'vio__rec-brief', m.briefing));
    var head = el('div', 'vio__rec-head');
    if (cfg.marks && cfg.marks.avatar) { var coin = el('span', 'vio__rec-coin'); coin.setAttribute('aria-hidden', 'true'); coin.innerHTML = cfg.marks.avatar; head.appendChild(coin); }
    head.appendChild(el('span', 'vio__rec-head-text', (p && typeof p.heading === 'function' ? p.heading({ all: state.more }) : '') || S.recHeading || 'YOUR SHADES, ALL FIVE, MATCHED TOGETHER'));
    c.appendChild(head);
    recRows(p, m.code).forEach(function (r) {
      var row = el('div', 'vio__row');
      if (r.available === false) row.classList.add('is-out');
      var sw = el('span', 'vio__swatch'); sw.setAttribute('role', 'img'); sw.setAttribute('aria-label', r.name + ' in ' + r.shade);
      if (r.pan) sw.style.backgroundImage = 'url(' + r.pan + ')';
      else if (r.role === 'concealer' && p && p.shades && p.shades[r.shade]) sw.style.backgroundColor = p.shades[r.shade].hex;
      row.appendChild(sw);
      if (r.url) {
        // The product page, with this shade selected on arrival.
        var link = el('a', 'vio__row-name vio__row-link', r.name); link.href = r.url;
        link.setAttribute('aria-label', fill(S.rowLinkAria || 'Open {name} in {shade}', { name: r.name, shade: r.shade }));
        row.appendChild(link);
      } else {
        row.appendChild(el('span', 'vio__row-name', r.name));
      }
      row.appendChild(el('span', 'vio__row-badge', r.available === false ? (S.badgeSoldOut || 'SOLD OUT') : r.badge));
      row.appendChild(el('span', 'vio__row-shade', r.shade));
      c.appendChild(row);
    });
    // Off the Stak pages: the rest of the shade products, on request.
    if (p && typeof p.canMore === 'function' && p.canMore(m.code)) {
      var more = btn('vio__btn vio__btn--ghost vio__btn--wide vio__more', state.more ? (S.matchFewer || 'Show fewer') : (S.matchMore || 'Match more products'), function () {
        state.more = !state.more; persist(); writeSiteRecord(state.code); render();
      });
      more.setAttribute('aria-expanded', state.more ? 'true' : 'false');
      c.appendChild(more);
    }
    if ((m.lowConfidence || m.held) && m.runnerUp) c.appendChild(altBlock(m, !!m.held));
    var acts = el('div', 'vio__rec-actions');
    var price = p && typeof p.priceFor === 'function' ? p.priceFor(m.code, { all: state.more }) : (p && p.price ? p.price : '');
    acts.appendChild(btn('vio__btn vio__btn--solid vio__btn--wide', fill(S.addAll || 'Add all to bag, {price}', { price: price }), addAll));
    acts.appendChild(el('span', 'vio__hint', S.pushback || 'Not quite right? Tell me. Too warm, too deep, anything.'));
    c.appendChild(acts);
    return c;
  }

  // The shade the customer asked for, offered as their call after a held read.
  function altCard(m) {
    var c = el('section', 'vio__rec vio__rec--alt');
    c.setAttribute('aria-label', S.runnerLabel || 'Or try this one');
    c.appendChild(altBlock(m, true));
    return c;
  }

  // The other shade: the one the customer's words pointed to on a held read,
  // or the runner-up on a less certain one, offered as their call. When the
  // page cannot sell it, there is no switch to offer, so Violet says so and
  // stands by her read: the shade she gave is in stock, and the free
  // exchange covers the doubt. A sold-out shade is never a dead end.
  function altBlock(m, held) {
    var p = page();
    var alt = el('div', 'vio__alt');
    var v = p && typeof p.variantFor === 'function' ? p.variantFor(m.runnerUp) : null;
    var out = !!(p && v && !v.a);
    var code = m.code || state.code;
    var note = out
      ? fill(S.runnerSoldOutNote || '{runner} is sold out right now. I still feel good about {code} for you, so give it a try. If it isn’t perfect, the exchange is free.', { runner: m.runnerUp, code: code })
      : (held ? (S.heldNote || 'If you are sure, it is right here. With the free exchange, either is a safe pick.') : (S.runnerNote || 'A little less certain than usual on this one, so here is the next closest. Free exchange means either is safe.'));
    alt.appendChild(el('span', 'vio__alt-note', note));
    var altRow = el('div', 'vio__alt-row');
    var altSw = el('span', 'vio__swatch'); altSw.setAttribute('role', 'img'); altSw.setAttribute('aria-label', 'Cream Concealer in ' + m.runnerUp + (out ? ', sold out' : ''));
    var altPan = p && p.panFor ? p.panFor('concealer', m.runnerUp) : '';
    if (altPan) altSw.style.backgroundImage = 'url(' + altPan + ')';
    else if (p && p.shades && p.shades[m.runnerUp]) altSw.style.backgroundColor = p.shades[m.runnerUp].hex;
    if (out) altSw.classList.add('is-out');
    altRow.appendChild(altSw);
    altRow.appendChild(el('span', 'vio__row-name', out ? fill(S.runnerSoldOutLabel || '{code}, sold out', { code: m.runnerUp }) : (S.runnerLabel || 'Or try this one')));
    if (out) altRow.appendChild(el('span', 'vio__row-badge', S.badgeSoldOut || 'SOLD OUT'));
    else altRow.appendChild(btn('vio__btn vio__btn--ghost vio__alt-btn', fill(S.runnerCta || 'Switch to {code}', { code: m.runnerUp }), function () { chooseRunnerUp(m); }));
    alt.appendChild(altRow);
    return alt;
  }

  function handoffCard(m) {
    var c = el('div', 'vio__hand');
    if (m.quote) c.appendChild(el('span', 'vio__hand-quote', '“' + m.quote + '”'));
    c.appendChild(btn('vio__btn vio__btn--solid', S.openChat || 'Open live chat', function () {
      close(); handoffToKustomer(m.quote);
    }));
    c.appendChild(el('span', 'vio__hint', S.handNote || 'Your match stays saved here, and support can pick up where I left off.'));
    return c;
  }

  // The handoff. Kustomer's chat opens on a NEW conversation that already
  // holds what the customer said, sent as their first message, and carries
  // the match id and shade as conversation attributes (the same
  // matchIdStr / shadeCodeStr the Worker writes on its own Kustomer records,
  // so support can join the two). The chat customer is described the same
  // way, with the email when Violet knows it.
  function handoffToKustomer(quote) {
    var K = window.Kustomer, p = page();
    if (!K || typeof K.createConversation !== 'function') { if (p && p.openKustomer) p.openKustomer(); return; }
    var custom = {};
    if (state.matchId) custom.matchIdStr = state.matchId;
    if (state.code) custom.shadeCodeStr = state.code;
    var message = String(quote || '').trim() || fill(S.handoffMessage || 'I was shade matching with Violet{shade} and would like to talk to a person.', { shade: state.code ? ' and matched to ' + state.code : '' });
    try {
      if (typeof K.describeCustomer === 'function') {
        var who = { customAttributes: custom };
        if (state.email) who.attributes = { emails: [state.email] };
        K.describeCustomer(who, function () {});
      }
    } catch (e) { /* attributes are a courtesy */ }
    try { K.open(); } catch (e) { /* ignore */ }
    try {
      K.createConversation({ message: message, customAttributes: custom }, function (res) {
        var id = res && (res.conversationId || (res.data && res.data.conversationId));
        if (id && typeof K.describeConversation === 'function') {
          try { K.describeConversation({ conversationId: id, customAttributes: custom }, function () {}); } catch (e) { /* ignore */ }
        }
        // The Worker tags the conversation "Violet" and writes the match on
        // it, since the chat SDK cannot tag; support finds it by the tag.
        if (id) {
          try {
            fetch(cfg.endpoint.replace(/\/$/, '') + '/handoff', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret }, keepalive: true,
              body: JSON.stringify({ conversation_id: String(id), match_id: state.matchId || null, code: state.code || null, session: sessionId() }),
            }).catch(function () { /* best effort */ });
          } catch (e) { /* ignore */ }
        }
      });
    } catch (e) { if (p && p.openKustomer) p.openKustomer(); }
  }

  function fallbackCard() {
    var c = el('div', 'vio__fall');
    c.appendChild(btn('vio__btn vio__btn--ghost', S.picker || 'Open the shade picker', function () { toPicker(); }));
    return c;
  }

  // Codes the page cannot sell right now, so the Worker never recommends
  // two unbuyable shades in a row.
  function unavailableCodes() {
    var p = page(); if (!p || !p.shades || !p.variantFor) return [];
    return Object.keys(p.shades).filter(function (c) { var v = p.variantFor(c); return v && !v.a; });
  }

  function toPicker() {
    close();
    var target = document.querySelector('#ssd10-shade');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // The sitewide record: the same {handle, shade} list the Kustomer script
  // applies on product pages, so a Violet match follows the shopper anywhere
  // on the site (assets/violet-shade-match.js reads it). Phase two makes it
  // the global source.
  function writeSiteRecord(code) {
    var p = page();
    if (!p || !code) return;
    try {
      var recs;
      if (typeof p.siteRecord === 'function') recs = p.siteRecord(code);
      else {
        var pr = p.pairingFor(code), h = p.handles || {}; recs = [];
        if (h.ssd && pr.bb) recs.push({ handle: h.ssd, shade: pr.bb });
        if (h.ssd) recs.push({ handle: h.ssd, shade: code });
        if (h.concealer) recs.push({ handle: h.concealer, shade: code });
        if (h.bb && pr.bb) recs.push({ handle: h.bb, shade: pr.bb });
        if (h.bronzer && pr.bronzer) recs.push({ handle: h.bronzer, shade: pr.bronzer });
        if (h.lipcheek && pr.lipcheek) recs.push({ handle: h.lipcheek, shade: pr.lipcheek });
        if (h.eyeshadow && pr.eyeshadow) recs.push({ handle: h.eyeshadow, shade: pr.eyeshadow });
      }
      window.localStorage.setItem('subtl:shade', JSON.stringify({ by: 'violet', match_id: state.matchId, concealer: code, at: Date.now(), picks: state.picks || null, recommendations: recs }));
    } catch (e) { /* private mode */ }
  }

  // Violet's selfie picks (blush, lip glaze, brow): newer ones win, older ones
  // fill the gaps. Returns true when something changed.
  function mergePicks(picks) {
    if (!picks || typeof picks !== 'object') return false;
    var cur = state.picks || {}, next = {}, changed = false;
    ['blush', 'lip_glaze', 'brow'].forEach(function (k) {
      next[k] = picks[k] || cur[k] || null;
      if (next[k] !== (cur[k] || null)) changed = true;
    });
    if (changed) state.picks = next;
    return changed;
  }

  function applyToPage(code) {
    var p = page();
    if (!p || !code) return;
    if (p.setPicks && state.picks) p.setPicks(state.picks);
    p.applyMatch(code, { by: 'violet', matchId: state.matchId, confidence: state.confidence, picks: state.picks });
    writeSiteRecord(code);
    // Hand the Worker every shade as the page resolved it, for Klaviyo and Kustomer.
    try {
      var pr = p.pairingFor(code);
      fetch(cfg.endpoint.replace(/\/$/, '') + '/pairing', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret },
        body: JSON.stringify({ match_id: state.matchId, pairing: { bb: pr.bb, bronzer: pr.bronzer, balm: pr.balm, lipcheek: pr.lipcheek, eyeshadow: pr.eyeshadow, blush: pr.blush, glaze: pr.glaze, highlighter: pr.highlighter, shine: pr.shine, brow: pr.brow || undefined } }),
      }).catch(function () { /* best effort */ });
    } catch (e) { /* ignore */ }
  }

  function addAll() {
    var p = page();
    if (!p || !state.code || state.adding) return;
    applyToPage(state.code);
    // A Stak page (or the landing page's bridge, which only sells the Stak)
    // speaks of the stak; a products page of everything that went in.
    var stakName = p.stakName || (typeof p.set === 'function' ? '' : 'stak');
    var line = stakName
      ? fill(S.added || 'Added. Your whole stak went in, keyed to {shade}.', { shade: state.code })
      : fill(S.addedProducts || 'Added. Everything went in, keyed to {shade}.', { shade: state.code });
    var r = p.addToBag({ all: state.more });
    if (r && typeof r.then === 'function') {
      state.adding = true;
      r.then(function (ok) { push({ t: 'a', text: ok ? line : (S.shopAddFailed || 'That did not make it into your bag. Try once more.') }); })
        .catch(function () { push({ t: 'a', text: S.shopAddFailed || 'That did not make it into your bag. Try once more.' }); })
        .then(function () { state.adding = false; });
    } else {
      push({ t: 'a', text: line });
    }
  }

  function chooseRunnerUp(m) {
    if (state.busy || !state.matchId || !m.runnerUp) return;
    var p = page(), v = p && p.variantFor ? p.variantFor(m.runnerUp) : null;
    if (p && v && !v.a) { push({ t: 'a', text: fill(S.runnerSoldOut || '{code} is sold out right now, so I’ll keep you on my first read.', { code: m.runnerUp }) }); return; }
    state.busy = true;
    fetch(cfg.endpoint.replace(/\/$/, '') + '/choose', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret },
      body: JSON.stringify({ match_id: state.matchId, code: m.runnerUp }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || !res.ok) throw new Error('choose');
        state.code = res.concealer_code; state.runnerUp = res.runner_up; state.revision = res.revision || state.revision + 1; state.title = m.title || state.title;
        mergePicks(res.picks);
        applyToPage(state.code);
        push({ t: 'a', text: fill(S.switched || 'Done. {shade} it is, and the rest of your stak follows it.', { shade: state.code }) });
        push({ t: 'rec', code: state.code, runnerUp: state.runnerUp, title: m.title, briefing: m.briefing, lowConfidence: false });
      })
      .catch(function () { push({ t: 'a', text: S.offline || 'I could not reach the matcher just now.' }); })
      .then(function () { state.busy = false; render(); });
  }

  // ── The session id and the open beacon ────────────────────────────────────
  // A browser id, minted once and kept, rides on every open and every selfie
  // so the dashboard can count "opened Violet → sent a selfie → got a shade
  // → ordered" per person. It carries nothing personal.
  var SID_KEY = 'subtl:violet:sid';
  function sessionId() {
    var id = null;
    try { id = window.localStorage.getItem(SID_KEY); } catch (e) { /* private mode */ }
    if (id && /^[A-Za-z0-9_-]{8,40}$/.test(id)) return id;
    id = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    try { window.localStorage.setItem(SID_KEY, id); } catch (e) { /* ignore */ }
    return id;
  }
  var openLogged = false;
  function logOpen(via) {
    if (openLogged) return;
    openLogged = true;
    try {
      fetch(cfg.endpoint.replace(/\/$/, '') + '/open', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret }, keepalive: true,
        body: JSON.stringify({ session: sessionId(), source: cfg.source || 'ssd-10a', page: window.location.pathname, via: via || 'page', has_match: !!state.matchId }),
      }).catch(function () { /* best effort */ });
    } catch (e) { /* ignore */ }
  }

  // ── Open / close (a dialog: focus in, trapped, back to the trigger) ────────

  function open(trigger) {
    if (state.open) return;
    state.open = true;
    state.lastFocus = trigger || document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('vio-open');
    logOpen(state.openSource || 'page');
    if (!state.thread.length) {
      push({ t: 'a', text: S.welcome || 'Hi, I’m Violet. Send me one makeup-free photo and in about ten seconds I’ll find the concealer that sits closest to your skin. The rest of your stak follows from it.' });
      push({ t: 'start' });
    } else {
      render();
    }
    violetOpened();
    window.setTimeout(function () { panel.focus(); }, 30);
  }

  // A fresh selfie. The current match stays on the page until a new read
  // lands, so a change of mind never blanks the page.
  function rematch(trigger) {
    stopCamera();
    state.busy = false;
    dropTyping();
    // Re-opening keeps the whole conversation; closing by accident must not
    // lose it. The recap is only for a thread that has nothing to show
    // (pruned, or restored from an older save), and the "look again?" nudge
    // plus photo buttons are appended once, never stacked.
    var last = state.thread[state.thread.length - 1] || {};
    var hasHistory = state.thread.some(function (m) { return m.t === 'rec' || m.t === 'u'; });
    var code = state.code, title = state.title;
    // A thread with history re-opens as it was: the composer, the chips and
    // the New photo chip are the ways forward. Nothing is appended.
    if (last.t === 'start' || hasHistory) {
      // History but nothing to talk to (no match on file, and the thread
      // ended on a card): offer the photo buttons again rather than a dead end.
      if (!state.matchId && last.t !== 'start' && last.t !== 'typing') push({ t: 'start' });
      if (!state.open) open(trigger); else { render(); window.setTimeout(function () { panel.focus(); }, 30); }
      return;
    }
    if (!hasHistory && code && state.matchId) {
      var p = page();
      var pr = p ? p.pairingFor(code) : {};
      var pods = p && typeof p.set === 'function'
        ? p.set(code, { all: false }).filter(function (r) { return r.role !== 'concealer'; }).map(function (r) { return r.shade + ' ' + r.name; })
        : [pr.bb && (pr.bb + ' BB Powder'), pr.bronzer && (pr.bronzer + ' Bronzer'), pr.lipcheek && (pr.lipcheek + ' Lip and Cheek'), pr.eyeshadow && (pr.eyeshadow + ' Eyeshadow')].filter(Boolean);
      var read = title ? title.charAt(0).toLowerCase() + title.slice(1) : '';
      push({ t: 'a', text: fill(S.recap || 'Last time I read you as {read} and matched you to {code}. Your stak followed it: {pods}.', { read: read || 'your shade', code: code, pods: pods.join(', ') }) });
    }
    push({ t: 'a', text: S.again || 'Want me to look again? Send a fresh photo, no makeup, in natural light, and I will read it from the start.' });
    push({ t: 'start', again: !!(code && state.matchId) });
    if (!state.open) open(trigger); else { render(); window.setTimeout(function () { panel.focus(); }, 30); }
  }

  function close() {
    if (!state.open) return;
    stopCamera();
    state.open = false;
    root.hidden = true;
    document.documentElement.classList.remove('vio-open');
    if (state.lastFocus && typeof state.lastFocus.focus === 'function') state.lastFocus.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) { if (e.target.closest('[data-violet-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') { e.preventDefault(); if (camView && !camView.hidden) stopCamera(); else close(); return; }
    if (e.key !== 'Tab') return;
    var focusables = panel.querySelectorAll('button:not([disabled]), input:not([type="file"]):not([disabled]), [tabindex]:not([tabindex="-1"])');
    focusables = Array.prototype.filter.call(focusables, function (n) { return n.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Every shade-match entry point opens Violet instead of chat. Capture
  // phase, so the layout's own Kustomer opener never sees the click.
  document.addEventListener('click', function (e) {
    var re = e.target.closest && e.target.closest('[data-ssd10-rematch]');
    if (re) { e.preventDefault(); e.stopImmediatePropagation(); rematch(re); return; }
    var t = e.target.closest && e.target.closest('[data-open-chat], [href="#openchat"]');
    if (!t || t.closest('[data-violet]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(t);
  }, true);

  // ── Camera ──────────────────────────────────────────────────────────────
  // A live view inside the flyout wherever getUserMedia exists; the file
  // input with capture="user" is the fallback (and the keyboard route).

  var stream = null;
  function openCamera() {
    if (!camView || !camVideo || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { camera.click(); return; }
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 1280 } }, audio: false })
      .then(function (s) {
        stream = s;
        camVideo.srcObject = s;
        camView.hidden = false;
        return camVideo.play();
      })
      .then(function () { var shot = camView.querySelector('[data-violet-cam-shoot]'); if (shot) shot.focus(); })
      .catch(function () { stopCamera(); camera.click(); });
  }
  function stopCamera() {
    if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; }
    if (camVideo) camVideo.srcObject = null;
    if (camView) camView.hidden = true;
  }
  function shoot() {
    if (!stream || !camVideo.videoWidth) return;
    var w = camVideo.videoWidth, h = camVideo.videoHeight;
    var k = Math.min(1, 1024 / Math.max(w, h));
    var c = document.createElement('canvas');
    c.width = Math.round(w * k); c.height = Math.round(h * k);
    var ctx = c.getContext('2d');
    ctx.translate(c.width, 0); ctx.scale(-1, 1);        // un-mirror the preview
    ctx.drawImage(camVideo, 0, 0, c.width, c.height);
    stopCamera();
    takeIn(c);
  }
  if (camView) {
    camView.addEventListener('click', function (e) {
      if (e.target.closest('[data-violet-cam-shoot]')) shoot();
      else if (e.target.closest('[data-violet-cam-cancel]')) stopCamera();
    });
  }

  // ── Selfie in ────────────────────────────────────────────────────────────

  [camera, upload].forEach(function (input) {
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      input.value = '';
      if (!file) return;
      decode(file).then(takeIn).catch(function () {
        push({ t: 'a', text: S.badFile || 'That file did not open for me. A JPEG or PNG from your camera roll works best.' });
        push({ t: 'start' });
      });
    });
  });

  // Down to 1024px on the long edge, on a canvas we can also measure.
  function decode(file) {
    return new Promise(function (resolve, reject) {
      if (!/^image\//.test(file.type)) return reject(new Error('type'));
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        try {
          var max = 1024, w = img.naturalWidth, h = img.naturalHeight;
          var k = Math.min(1, max / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.round(w * k); c.height = Math.round(h * k);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          resolve(c);
        } catch (err) { reject(err); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }

  // The photo-quality check the spec asks for: a read cannot be right under
  // very dark or blown-out light, so ask for another photo before sending.
  function quality(canvas) {
    var s = document.createElement('canvas'); s.width = 32; s.height = 32;
    var ctx = s.getContext('2d'); ctx.drawImage(canvas, 0, 0, 32, 32);
    var d = ctx.getImageData(0, 0, 32, 32).data;
    var sum = 0, dark = 0, bright = 0, n = d.length / 4;
    for (var i = 0; i < d.length; i += 4) {
      var y = 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
      sum += y; if (y < 40) dark++; if (y > 240) bright++;
    }
    var mean = sum / n;
    if (mean < 55 || dark / n > 0.6) return 'dark';
    if (mean > 225 || bright / n > 0.5) return 'bright';
    return null;
  }

  function takeIn(canvas) {
    var q = quality(canvas);
    if (q) {
      push({ t: 'a', text: q === 'dark' ? (S.tooDark || 'That one is quite dark, and a shade read needs light. Try again facing a window, no flash.') : (S.tooBright || 'That one is washed out, so the undertone will not read true. Step back from the light and try again.') });
      push({ t: 'start' });
      return;
    }
    var dataUrl = canvas.toDataURL('image/jpeg', 0.86);
    push({ t: 'img', src: dataUrl });
    state.lastImage = dataUrl;
    send('/match', { image: dataUrl, source: cfg.source || 'ssd-10a', unavailable: unavailableCodes(), session: sessionId() });
  }

  // ── Worker round trip ────────────────────────────────────────────────────

  // ── The analysis progress ─────────────────────────────────────────────────
  // While a selfie is being read, Violet's side of the thread shows what she
  // is doing: one line per step, a bar that fills as she goes, her heart
  // riding its end, and a scan line over the selfie. Each run picks a fresh
  // wording for every step from the pools in the config, so no two reads
  // narrate themselves the same way. The steps advance on a clock; the last
  // one holds until the Worker answers.
  var STEP_MS = 1600;
  var progress = { on: false, i: 0, lines: [], timer: null, startedAt: 0 };
  var STEP_FALLBACK = [['Reading the skin under your eyes'], ['Checking that against your jawline'], ['Down to three shades that could be you'], ['A quick look at your cheeks to be sure'], ['Settling on your shade']];
  function pickLines() {
    var pools = Array.isArray(S.progressSteps) && S.progressSteps.length ? S.progressSteps : STEP_FALLBACK;
    return pools.map(function (pool, n) {
      var list = Array.isArray(pool) && pool.length ? pool : (STEP_FALLBACK[n] || ['One moment']);
      return list[Math.floor(Math.random() * list.length)];
    });
  }
  function startProgress() {
    stopProgress();
    progress.on = true; progress.i = 0; progress.lines = pickLines(); progress.startedAt = Date.now();
    var step = function () {
      if (!progress.on) return;
      if (progress.i < progress.lines.length - 1) { progress.i++; paintProgress(); progress.timer = window.setTimeout(step, STEP_MS); }
    };
    progress.timer = window.setTimeout(step, STEP_MS);
  }
  function stopProgress() {
    progress.on = false;
    if (progress.timer) { window.clearTimeout(progress.timer); progress.timer = null; }
  }
  function progressPct() { return Math.round(((progress.i + 1) / Math.max(1, progress.lines.length)) * 100); }
  // Update the node in place, so the bar slides rather than rebuilds.
  function paintProgress() {
    var node = thread.querySelector('[data-violet-progress]');
    if (!node) return;
    var txt = node.querySelector('[data-violet-progress-text]');
    if (txt && txt.textContent !== progress.lines[progress.i]) {
      txt.textContent = progress.lines[progress.i];
      txt.classList.remove('is-in'); void txt.offsetWidth; txt.classList.add('is-in');
    }
    var pct = progressPct() + '%';
    var fill = node.querySelector('[data-violet-progress-fill]'); if (fill) fill.style.width = pct;
    var mark = node.querySelector('[data-violet-progress-mark]'); if (mark) mark.style.left = pct;
    node.setAttribute('aria-valuenow', String(progressPct()));
  }
  function progressCard() {
    var c = el('div', 'vio__progress');
    c.setAttribute('data-violet-progress', '');
    c.setAttribute('role', 'progressbar'); c.setAttribute('aria-valuemin', '0'); c.setAttribute('aria-valuemax', '100'); c.setAttribute('aria-valuenow', String(progressPct()));
    c.setAttribute('aria-label', S.progressAria || 'Violet is reading your selfie');
    var txt = el('span', 'vio__progress-text is-in', progress.lines[progress.i] || '');
    txt.setAttribute('data-violet-progress-text', ''); txt.setAttribute('aria-live', 'polite');
    c.appendChild(txt);
    var track = el('div', 'vio__progress-track');
    var rail = el('span', 'vio__progress-rail');
    var fill = el('span', 'vio__progress-fill'); fill.setAttribute('data-violet-progress-fill', ''); fill.style.width = progressPct() + '%';
    var mark = el('span', 'vio__progress-mark'); mark.setAttribute('data-violet-progress-mark', ''); mark.setAttribute('aria-hidden', 'true'); mark.style.left = progressPct() + '%';
    var beat = el('span', 'vio__progress-heart');
    beat.innerHTML = '<svg viewBox="0 0 48 48" width="18" height="18" aria-hidden="true" focusable="false"><g transform="rotate(-10 24 24)"><path d="M24 39 C14 30 10.5 23.5 15 18.5 C18.4 14.8 23 16.7 24 21 C25 16.7 29.6 14.8 33 18.5 C37.5 23.5 34 30 24 39 Z" fill="#57201F"/><circle cx="19.5" cy="22" r="3.2" fill="#FFC0F8" fill-opacity="0.55"/></g></svg>';
    mark.appendChild(beat);
    track.appendChild(rail); track.appendChild(fill); track.appendChild(mark);
    c.appendChild(track);
    return c;
  }

  function send(path, body) {
    if (state.busy) return;
    state.busy = true;
    dropTyping();
    if (path === '/match') { startProgress(); push({ t: 'progress' }); } else push({ t: 'typing' });
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 45000) : null;
    fetch(cfg.endpoint.replace(/\/$/, '') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret },
      body: JSON.stringify(body),
      signal: controller ? controller.signal : undefined,
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { handle(res); })
      .catch(function () {
        dropTyping();
        push({ t: 'a', text: S.offline || 'I could not reach the matcher just now.', link: state.lastImage ? (S.retryLink || 'Try that photo again.') : (S.pickerLink || 'Pick a shade on the page instead.'), action: state.lastImage ? 'retry' : 'picker' });
        push({ t: 'start' });
      })
      .then(function () { if (timer) clearTimeout(timer); state.busy = false; render(); });
  }

  function handle(res) {
    dropTyping();
    if (!res || typeof res !== 'object') { push({ t: 'a', text: S.offline || 'Something went wrong on our side.', link: state.lastImage ? (S.retryLink || 'Try that photo again.') : (S.pickerLink || 'Pick a shade on the page instead.'), action: state.lastImage ? 'retry' : 'picker' }); push({ t: 'start' }); return; }
    if (res.match_id) { state.matchId = res.match_id; state.revision = res.revision || 0; }

    if (res.ok && res.save) {
      push({ t: 'a', text: res.reply || '' });
      var known = knownEmail();
      if (known) {
        if (!state.email) { state.email = known; persist(); }
        identifyQuietly(known);
        push({ t: 'a', text: fill(S.saved || 'Saved. Your match is on file for {email}, and I’ll be in touch.', { email: known }) });
      } else {
        // Bring the save panel to the bottom of the thread, whether or not it was shown before.
        state.thread = state.thread.filter(function (x) { return !(x.t === 'save' && !x.done); });
        push({ t: 'save' });
      }
      return;
    }
    if (res.ok && res.answered) {
      push({ t: 'a', text: res.reply || '' });
      // An answer can carry a pick the match did not have yet (a brow
      // question on an older match): take it and re-apply, so the page and
      // the sitewide record follow what she just said.
      if (mergePicks(res.picks) && state.code) { persist(); applyToPage(state.code); }
      // An answer about brushes, applying or refills points at the products
      // it mentions; the Worker only names handles this page sent as sellable.
      if (Array.isArray(res.products) && res.products.length) push({ t: 'shop', handles: res.products, heading: S.shopAnswerHeading || 'What I would reach for' });
      return;
    }
    if (res.ok && res.concealer_code && !res.held && (res.concealer_code === state.code || res.concealer_code === state.switchedFrom)) {
      push({ t: 'a', text: res.briefing || res.reply || '' });
      return;
    }
    if (res.ok && res.held) {
      // She holds her read: her words, then the shade they asked for as a choice.
      state.runnerUp = res.runner_up || state.runnerUp;
      push({ t: 'a', text: res.briefing || '' });
      if (res.runner_up) push({ t: 'alt', code: state.code, runnerUp: res.runner_up, title: state.title, briefing: res.briefing || '' });
      return;
    }
    if (res.ok && res.concealer_code) {
      state.code = res.concealer_code; state.runnerUp = res.runner_up || null; state.confidence = res.confidence || 0; state.title = res.title || '';
      // The color products Violet picked from the selfie (blush, lip glaze),
      // for the pages whose sets include them.
      mergePicks(res.picks);
      // Stock honesty: the page knows every Stak variant's availability. If the
      // best read is sold out, say so and move to the runner-up when it is in
      // stock; if both are out, say that too and offer to save the match.
      var p = page();
      var best = p && p.variantFor ? p.variantFor(state.code) : null;
      if (p && best && !best.a) {
        var ru = state.runnerUp, alt = ru ? p.variantFor(ru) : null;
        if (alt && alt.a) {
          push({ t: 'a', text: fill(S.soldOutSwitch || 'My best read for you is {code}, but that shade is sold out right now. The next closest is {runner}, and it’s in stock, so I’ve set your stak to that.', { code: state.code, runner: ru }) });
          var was = state.code;
          state.code = ru; state.runnerUp = was; state.switchedFrom = was;
          fetch(cfg.endpoint.replace(/\/$/, '') + '/choose', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Subtl-Page': cfg.secret }, body: JSON.stringify({ match_id: state.matchId, code: ru, reason: 'best match ' + was + ' sold out' }) }).catch(function () {});
          applyToPage(state.code);
          push({ t: 'rec', code: state.code, runnerUp: null, title: res.title || '', briefing: res.briefing || '', lowConfidence: false });
        } else {
          push({ t: 'a', text: fill(S.soldOutBoth || 'My best read for you is {code}, and the next closest is {runner}, but both are sold out right now. Save your match below and I’ll let you know the moment they’re back.', { code: state.code, runner: ru || 'the next shade' }), link: S.pickerLink || 'Or pick another shade on the page.' });
          if (!knownEmail() && !state.thread.some(function (x) { return x.t === 'save'; })) push({ t: 'save' });
        }
        return;
      }
      applyToPage(state.code);
      push({ t: 'rec', code: state.code, runnerUp: state.runnerUp, title: res.title || '', briefing: res.briefing || '', lowConfidence: !!res.low_confidence, held: !!res.held });
      var known = knownEmail();
      if (known) {
        // Already identified: log the match everywhere, ask nothing, subscribe to nothing.
        if (!state.email) { state.email = known; persist(); }
        identifyQuietly(known);
      } else if (!state.thread.some(function (x) { return x.t === 'save'; })) {
        push({ t: 'save' });
      }
      return;
    }

    var problem = res.problem || 'model_error';
    var message = res.message || S.offline || 'Something went wrong on our side.';
    if (problem === 'off_topic') {
      var lastUser = state.thread.slice().reverse().find(function (m) { return m.t === 'u'; });
      push({ t: 'a', text: message });
      push({ t: 'hand', quote: lastUser ? lastUser.text : '' });
      return;
    }
    if (problem === 'too_many_revisions') { push({ t: 'a', text: message }); push({ t: 'hand' }); return; }
    if (problem === 'no_face' || problem === 'multiple_faces' || problem === 'lighting' || problem === 'too_close' || problem === 'makeup' || problem === 'out_of_set') {
      push({ t: 'a', text: message }); push({ t: 'start' }); return;
    }
    push({ t: 'a', text: message, link: state.lastImage ? (S.retryLink || 'Try that photo again.') : (S.pickerLink || 'Pick a shade on the page instead.'), action: state.lastImage ? 'retry' : 'picker' });
    push({ t: 'start' });
  }

  // ── Pushback ─────────────────────────────────────────────────────────────

  // Two things never need the matcher: asking to save or email the match,
  // and a thank-you. Both are handled here, instantly and predictably.
  var SAVE_RE = /\b(e-?mail|send (this|it|that|me|my)|save (this|it|that|my)|a copy|keep (this|it|my)|text me)\b/i;
  // Asking to see the match again, in the flyout: the card is re-shown as it was.
  var SHOW_RE = /\b(show|see|display|list|remind|repeat|resend|send|give|pull up|bring up|what (are|were|is|was)|which)\b[\s\S]*\b(shades?|matches?|recommendations?|picks?|stak|results?|colou?rs?|them|those|it)\b|\b(shades?|matches?|recommendations?|results?|them|it)\b[\s\S]*\bagain\b/i;
  var THANKS_RE = /^\s*(thanks?( you)?|thank u|thx|ty|cheers|ok(ay)?|cool|great|perfect|awesome|love it|got it)[\s!.]*(thanks?|thank you)?[\s!.]*$/i;

  function feedback(txt) {
    txt = String(txt || '').trim();
    if (!txt || !state.matchId || state.busy) return;
    push({ t: 'u', text: txt });
    // "Show me my shades again": the card comes back as it was, no round
    // trip. Only an email, a copy or a save is a save; "send me the shades
    // again" wants them here. "Look again" is a re-read and goes to the Worker.
    if (state.code && SHOW_RE.test(txt) && !/\b(e-?mail|mail|copy|save|keep|text me)\b/i.test(txt) && !/\b(look|read|check|scan|photo|selfie|picture)\b/i.test(txt)) {
      var lastRec = state.thread.slice().reverse().find(function (x) { return x.t === 'rec'; }) || {};
      push({ t: 'a', text: S.showAgain || 'Here they are again.' });
      push({ t: 'rec', code: state.code, runnerUp: state.runnerUp, title: lastRec.title || state.title || '', briefing: lastRec.briefing || '', lowConfidence: false, held: false });
      return;
    }
    if (state.code && SAVE_RE.test(txt) && !/\b(too|darker|lighter|warm|cool|deep|light|shade)\b/i.test(txt)) {
      handle({ ok: true, save: true, reply: S.saveReply || 'Happy to. Pop your email in below and I’ll keep your match on file and send it over.' });
      return;
    }
    if (THANKS_RE.test(txt)) {
      push({ t: 'a', text: S.thanksReply || 'Any time. Your match is right here whenever you need it.' });
      return;
    }
    send('/revise', { match_id: state.matchId, feedback: txt, unavailable: unavailableCodes(), companions: companionList() });
  }
  // Follow-up chips. Tools and Refills are answered here from the companion
  // catalog; an "ask" chip sends its question to the Worker as if typed; any
  // other chip sends its label.
  chips.addEventListener('click', function (e) {
    var c = e.target.closest('[data-violet-chip]'); if (!c || state.busy || !state.matchId) return;
    var kind = c.getAttribute('data-violet-chip');
    if (kind === 'tools' || kind === 'refills') { push({ t: 'u', text: c.textContent.trim() }); showCompanions(kind); return; }
    feedback(kind === 'ask' ? (c.getAttribute('data-violet-ask') || c.textContent) : c.textContent);
  });
  // The camera button in the composer: a new photo at any point in the
  // conversation. The native picker offers the camera on a phone.
  var newPhoto = root.querySelector('[data-violet-newphoto]');
  if (newPhoto) newPhoto.addEventListener('click', function () { if (!state.busy) upload.click(); });
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = text.value; text.value = ''; feedback(v); });

  // ── After the page adds to bag: carry the match id on the cart ──────────
  // So the checkout and order webhooks can join without an email.
  document.addEventListener('subtl:ssd10:added', function () {
    if (!state.matchId) return;
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootPath + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { violet_match_id: state.matchId, violet_shade: state.code || '' } }),
    }).catch(function () { /* best effort */ });
  });

  // ── Klaviyo, onsite ──────────────────────────────────────────────────────
  // "Violet Opened" for the opened-but-no-selfie flow. Klaviyo's onsite
  // script attaches it to the profile once the visitor is identified; the
  // "Shade Matched" event itself is sent server-side when an email is known.
  //
  // It waits for the current Klaviyo object. Until the app embed's klaviyo.js
  // arrives, window.klaviyo is the legacy back-in-stock object from
  // snippets/klaviyo-bis.liquid, which drops a 'track' push; an email-link
  // open 250ms after load used to land there. The current object (or its
  // queueing stub) answers isIdentified; the legacy one does not.
  function klaviyoReady() {
    var k = window.klaviyo;
    return !!k && typeof k.push === 'function' && typeof k.isIdentified === 'function';
  }
  function violetOpened() {
    if (state.openedSent) return;
    state.openedSent = true;
    var props = { source: cfg.source || 'ssd-10a', via: state.openSource || 'page', has_match: !!state.matchId, page: window.location.pathname };
    var tries = 0;
    (function send() {
      if (klaviyoReady()) {
        try { window.klaviyo.push(['track', 'Violet Opened', props]); } catch (e) { /* ignore */ }
        return;
      }
      // About thirty seconds, then give up; a later open tries again.
      if (++tries > 100) { state.openedSent = false; return; }
      window.setTimeout(send, 300);
    })();
  }

  // ── The floating bubble ─────────────────────────────────────────────────
  // Her launcher on every page (markup in snippets/ssd-10a-violet.liquid).
  // With a match on file the coin carries her heart and the label names the
  // shade; a tap then reopens the conversation as it was (rematch), a first
  // tap opens fresh. The label shows itself once per visit, briefly.
  var fab = document.querySelector('[data-violet-fab]');
  var fabLabel = fab ? fab.querySelector('[data-violet-fab-label]') : null;
  var fabBadge = fab ? fab.querySelector('[data-violet-fab-badge]') : null;
  var fabIdle = (fabLabel && fabLabel.textContent.trim()) || 'Your shade, in ten seconds';
  function syncFab() {
    if (!fab) return;
    var code = state.code;
    if (fabBadge) fabBadge.hidden = !code;
    var label = code ? fill(S.fabMatched || 'Your shade, {code}', { code: code }) : fabIdle;
    if (fabLabel) fabLabel.textContent = label;
    fab.setAttribute('aria-label', label + '. Open Violet, the shade matcher.');
  }
  if (fab) {
    fab.hidden = false;
    fab.addEventListener('click', function () {
      state.openSource = 'bubble';
      fab.classList.remove('is-nudging');
      if (state.code && state.matchId) rematch(fab); else open(fab);
    });
    syncFab();
    // Above any bar pinned to the bottom edge while it shows: the product
    // page's sticky add-to-bag, the landing page's sticky CTA, whatever a
    // template adds. A bar counts when it is fixed, visible, wide, and
    // touching the bottom of the viewport; the bubble rides on top of the
    // tallest one and drops back down when it goes. Measured on scroll and
    // resize (throttled) and when a known bar's style or class changes.
    var BAR_SEL = '.product-sticky-bottom, .ssd10__sticky, [class*="sticky-bottom"], [class*="sticky-bar"], [class*="sticky-cta"]';
    function bottomBar() {
      var best = 0, nodes = document.querySelectorAll(BAR_SEL);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n === fab || fab.contains(n)) continue;
        var cs = window.getComputedStyle(n);
        if (cs.display === 'none' || cs.visibility === 'hidden' || (cs.position !== 'fixed' && cs.position !== 'sticky')) continue;
        var r = n.getBoundingClientRect();
        if (r.height < 30 || r.height > 220 || r.width < window.innerWidth * 0.6) continue;
        if (r.bottom < window.innerHeight - 4 || r.top >= window.innerHeight) continue;
        var h = window.innerHeight - r.top;
        if (h > best) best = h;
      }
      return best;
    }
    function liftFab() {
      var h = bottomBar();
      fab.classList.toggle('vio-fab--lifted', h > 0);
      if (h > 0) fab.style.setProperty('--vio-fab-lift', (h + 14) + 'px');
    }
    var liftTimer = null;
    function liftSoon() { if (liftTimer) return; liftTimer = window.setTimeout(function () { liftTimer = null; liftFab(); }, 120); }
    liftFab();
    window.setTimeout(liftFab, 1500);
    window.addEventListener('scroll', liftSoon, { passive: true });
    window.addEventListener('resize', liftSoon);
    if ('MutationObserver' in window) {
      var barWatch = new MutationObserver(liftSoon);
      Array.prototype.forEach.call(document.querySelectorAll(BAR_SEL), function (n) { barWatch.observe(n, { attributes: true, attributeFilter: ['style', 'class'] }); });
    }
    var NUDGED = 'subtl:violet-fab';
    var nudged = false;
    try { nudged = !!window.sessionStorage.getItem(NUDGED); } catch (e) { /* ignore */ }
    if (!nudged) {
      try { window.sessionStorage.setItem(NUDGED, '1'); } catch (e) { /* ignore */ }
      window.setTimeout(function () { if (!state.open) fab.classList.add('is-nudging'); }, 1800);
      window.setTimeout(function () { fab.classList.remove('is-nudging'); }, 8000);
    }
  }

  window.SubtlViolet = { open: open, close: close, rematch: rematch, matchId: function () { return state.matchId; } };

  // Deep link: a CTA elsewhere ("Show me my shade" in email, ads, the nav)
  // lands with Violet already open. Two spellings, because link trackers
  // often drop the hash:
  //   …/pages/starter-stak-deluxe-shade-match?violet=open
  //   …/pages/starter-stak-deluxe-shade-match#openchat
  // The trigger is removed from the address bar once she is shown, so a
  // reload or the back button after closing does not reopen her.
  //
  // Only once she can be seen. Mail apps on a phone (Outlook on iPhone) often
  // load the link into a tab that is not in front yet, and Safari may reload
  // that tab when the shopper finally switches to it. So she waits for the
  // tab to be visible, and the trigger stays in the address until then: a
  // reload before that still lands with her open.
  (function () {
    var byQuery = /[?&]violet=(open|1|true)(&|$)/i.test(window.location.search);
    var hash = window.location.hash;
    var byHash = hash === '#openchat' || hash === '#violet';
    if (!byQuery && !byHash) return;
    state.openSource = byQuery ? 'link' : 'hash';
    var started = false;
    function strip() {
      if (!byQuery || !window.history || !window.history.replaceState) return;
      var qs = window.location.search;
      var clean = window.location.pathname + qs.replace(/([?&])violet=[^&]*(&|$)/i, function (m, lead, tail) { return tail ? lead : ''; }).replace(/^&/, '?');
      if (clean.slice(-1) === '?') clean = clean.slice(0, -1);
      try { window.history.replaceState(window.history.state, '', clean); } catch (e) { /* ignore */ }
    }
    function go() {
      if (started || document.visibilityState === 'hidden') return;
      started = true;
      document.removeEventListener('visibilitychange', go);
      // A beat after she can be seen, so the page is there behind her when
      // she slides in. A plain timer, not an animation frame.
      window.setTimeout(function () { open(null); strip(); }, 250);
    }
    document.addEventListener('visibilitychange', go);
    go();
  })();
})();
